<template>
    <div class="row">
        <div class="col-md-8 offset-2">
            <card title="Crear solicitud">
                <form>
                    <div class="form-group">
                        <label for="business-unit">Unidad de negocio</label>
                        <v-select style="z-index: 10003" :disabled="businessUnits.length == 1" id="business-unit" v-model="businessUnit" @input="onBusinessUnitChange" :options="businessUnits">
                            <span slot="no-options">No se encontraron unidades de negocio</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div :class="hasMultipleCeco ? 'col-md-11' : 'col-md-12'">
                                <label for="cost-center">Centro de Costo <span class="text-danger">(*)</span></label>
                                <v-select style="z-index: 10002" :options="assignedCostCenters" :filterable="false" v-model="costCenter" @search="onSearch" :disabled="hasSingleCeco || hasNoCeco">
                                    <template slot="no-options">
                                        No se encontraron registros
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.label }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.label }}
                                        </div>
                                    </template>
                                </v-select>
                                <div v-if="hasNoCeco" class="text-danger small mt-1">
                                    Su usuario no posee un Centro de Costo asignado, se debe contactar con un administrador para su configuración.
                                </div>
                            </div>
                            <div class="col-md-1" v-if="hasMultipleCeco">
                                <button type="button" @click="showCostCenterUsersModal" class="btn btn-sm btn-info" style="margin-top: 32px;"><i class="fas fa-eye"></i></button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="required-dispatch-date">Fecha requerida Despacho</label>
                        <input type="date" :min="minDate" class="form-control" id="required-dispatch-date" v-model="createRequest.RequiredDispatchDate" >
                    </div>
                    <div class="form-group">
                        <label for="required-dispatch-date">Despacho Progresivo</label>
                        <b-form-checkbox @change="progressDispatchChange()" v-model="createRequest.ProgressDispatch"
                                name="check-button"
                                switch
                                class="mt-2"
                            >{{label}}
                        </b-form-checkbox>
                    </div>
                    <div class="form-group">
                        <label for="Sampletarget">Objetivo de la Muestra</label>
                        <v-select style="z-index: 10001" v-model="sampleTarget" :options="sampleTargets" id="Sampletarget" >
                            <span slot="no-options">No se encontraron Objetivos de Muestra</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-11">
                                <label for="SampleReason">Detalles de objetivo <span v-if="sampleReasonRequired" class="text-danger">*</span></label>
                                <v-select style="z-index: 10000" v-model="sampleReason" :options="sampleReasons" id="SampleReason" >
                                    <span slot="no-options">No se encontraron Detalles de objetivo</span>
                                </v-select>
                            </div>
                            <div class="col-md-1">
                                <button type="button" class="btn btn-sm btn-success" @click="addNewSampleReason()" style="margin-top: 32px;"><i class="fas fa-plus"></i></button>                            
                            </div>
                        </div>
                    </div>                  
                    <div class="form-group">
                        <button title="Guardar Nueva Solicitud" @click.prevent="save" class="btn btn-success btn-block">
                            <i class="fa fa-save"></i> Guardar
                        </button>
                        <router-link to="/" class="btn btn-secondary btn-block" title="Volver al listado de Solicitudes">
                            <i class="fa fa-arrow-left"></i> Volver
                        </router-link>
                    </div>
                </form>
            </card>
        </div>
        <modal id="costCenterUsersModal" title="Centro de Costos asociados" @modalClose="modalClose" :md="true">
            <show-cost-center-users :costCenterUsers="costCenterUsers"></show-cost-center-users>
        </modal>
    </div>
</template>

<script>
import Card from '../../components/Card.vue'
import {Get, Post} from '../../helper/axios.js'
import toastr from "toastr";
import _ from "lodash";
import $ from "jquery";
export default {
    components: {
        Card
    },
    name: 'CreateRequestView',
    data() {
        return {
            createRequest: {
                CostCenterId: 0,
                RequiredDispatchDate: '',
                SampleTargetId: 0,
                UserId: '0',
                ProgressDispatch: false
            },
            businessUnits: [],
            sampletarget:[],
            costCenters: [],
            costCenter: {},
            businessUnit: {},
            sampleTargets: [],
            sampleTarget: {},
            costCenterUsers: [],
            costCenterUsersLoaded: false,
            sampleReasons: [],
            sampleReason: {},
            Get,
            Post,
            apiUrl: this.$store.getters.apiUrl,
            label: "No",
            minDate: '',
            //search: '',
            offset: 0,
            limit: 10,
        }
    },
    computed: {
        // "Detalles de objetivo" es obligatorio solo si el Objetivo seleccionado lo exige.
        sampleReasonRequired() {
            return !!(this.sampleTarget && this.sampleTarget.requiresDetailSpecification);
        },
        // Opciones del select = centros de costo asignados al usuario.
        assignedCostCenters() {
            return (this.costCenterUsers || []).map(cc => ({
                code: cc.id,
                label: `${cc.name} (${cc.description})`
            }));
        },
        hasSingleCeco() {
            return this.costCenterUsersLoaded && this.costCenterUsers.length === 1;
        },
        hasMultipleCeco() {
            return this.costCenterUsersLoaded && this.costCenterUsers.length > 1;
        },
        hasNoCeco() {
            return this.costCenterUsersLoaded && this.costCenterUsers.length === 0;
        }
    },
    created() {
        this.getBusinessUnits();
        this.getSampleTarget();
        this.getSampleReasons();
        var today = new Date();
        var dd = String(today.getDate() + 2).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        this.minDate = yyyy + '-' + mm + '-' + dd;
    },
    methods: {
        getBusinessUnits() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl+'v1/businessunits', (res) => {
                res.data.data.forEach(element => {
                    this.businessUnits.push({
                        label: element.name,
                        code: element.id
                    });
                });

                if (res.data.data.length === 1)
                {
                    this.businessUnit = 
                    {
                        label: res.data.data[0].name,
                        code: res.data.data[0].id
                    }
                    this.getCostCenters();
                    this.getCostCenterUsers();
                }
                this.$store.commit("setLoading", false);
            })
        },
        getSampleTarget() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl+'v1/sampletarget/all', (res) => {
                res.data.data.forEach(element => {
                    this.sampleTargets.push({
                        label: element.name,
                        code: element.id,
                        requiresDetailSpecification: element.requiresDetailSpecification
                    });
                });
                this.$store.commit("setLoading", false);
            })
        },
        getSampleReasons() {
            this.sampleReasons = []
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl+'v1/samplereasons/all', (res) => {
                res.data.data.forEach(element => {
                    this.sampleReasons.push({
                        label: element.name,
                        code: element.id
                    });
                });
                this.$store.commit("setLoading", false);
            })
        },        
        getCostCenters() {
            if (this.businessUnit.code) {
                this.$store.commit("setLoading", true);
                this.Get(`${this.apiUrl}v1/businessunit/${this.businessUnit.code}/costcenters`, (res) => {
                    this.costCenters = [];
                    res.data.forEach(item => { 
                        this.costCenters.push({
                            code: item.id,
                            label: `${item.name} (${item.description})`
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
            }
        },
        // Se dispara al cambiar la unidad de negocio: recarga cecos del usuario y limpia la selección.
        onBusinessUnitChange() {
            this.costCenter = {};
            this.costCenterUsersLoaded = false;
            this.getCostCenters();
            this.getCostCenterUsers();
        },
        getCostCenterUsers(){
            if (this.businessUnit.code) {
                this.$store.commit("setLoading", true);
                this.Get(`${this.apiUrl}v1/CostCenterUsers/GetCostCenterByUser/${this.businessUnit.code}`, (res) => {
                    this.costCenterUsers = res.data || [];
                    this.costCenterUsersLoaded = true;
                    // Si el usuario tiene un único centro de costo asignado, se selecciona automáticamente.
                    if (this.costCenterUsers.length === 1) {
                        let cc = this.costCenterUsers[0];
                        this.costCenter = { code: cc.id, label: `${cc.name} (${cc.description})` };
                    } else {
                        this.costCenter = {};
                    }
                    this.$store.commit("setLoading", false);
                });
            }
        },
        save() {
            var valid = true;
            var message = "Agregue o corrija los siguiente campos:<br>";
            if (!this.businessUnit.code) {
                message = message + "* Unidad de Negocio.<br>";
                valid = false;
            }
            if (!this.costCenter.code) {
                message = message + "* Centro de Costo.<br>";
                valid = false;
            }
            if(!this.createRequest.RequiredDispatchDate){
                message = message + "* Fecha requerida de Despacho.<br>";
                valid = false;
            }
            else{
                if (this.createRequest.RequiredDispatchDate < this.minDate) {
                    message = message + "* La Fecha requerida de Despacho, No está permitida.<br>";
                    valid = false;
                }
            }
           
            if (!this.sampleTarget.code) {
                message = message + "* Objetivo de la Muestra.<br>";
                valid = false;
            }
            if (this.sampleReasonRequired && !this.sampleReason.code) {
                message = message + "* Detalles de objetivo.<br>";
                valid = false;
            }
            if (valid){
                if (this.costCenter.code) {
                    this.createRequest.CostCenterId = this.costCenter.code;
                    this.createRequest.SampleTargetId = this.sampleTarget.code;
                    this.createRequest.SampleReasonId = this.sampleReason.code;
                    this.$store.commit("setLoading", true);
                    this.Post(this.apiUrl+'v1/requestsamples', this.createRequest, (res) => {
                        this.$store.commit("setLoading", false);
                        this.$router.push('/solicitudes/ver/'+res.data.id);
                    });
                }
            }
            else toastr.info(message);
        },
        addNewSampleReason() {
            this.$swal({
                title: "Agregar nuevo Detalle de objetivo",
                input: "text",
                inputPlaceholder: 'Ingrese el detalle',
                inputValidator: (value) => {
                    if (!value || !value.trim()) {
                        return 'Debe ingresar un detalle'
                    }
                },
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                let reason = result.value;

                let existingReason = this.sampleReasons.find(
                    r => r.label.toLowerCase() === reason.toLowerCase()
                );

                if (existingReason) {
                    this.sampleReason = existingReason;
                    window.toastr.info('El detalle ya existe, se seleccionó automáticamente.');
                    return;
                }

                let data = {
                    name: reason
                }
                this.$store.commit("setLoading", true);
                this.Post(`${this.apiUrl}v1/sampleReasons/`, data, (res) => {
                    this.$store.commit("setLoading", false);
                    window.toastr.success('Detalle de objetivo registrado correctamente.');
                    this.getSampleReasons();

                    this.sampleReason = {
                        code: res.data.data.id,
                        label: res.data.data.name
                    }
                });
            });
        },            
        progressDispatchChange(){
            if (this.label == "No"){
                this.label = "Si";
            }
            else if (this.label == "Si")
                this.label = "No";

        },
        showCostCenterUsersModal(){
            $('#costCenterUsersModal').modal('show')
        },
        modalClose(){
            $('#costCenterUsersModal').modal('hide')
        },
        onSearch(search, loading) {
            if(search.length)
            {
                loading(true);
                this.search(loading, search, this)
            }
        },
        search: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&BusinessUnitId=" + vm.businessUnit.code;
            vm.Get(vm.apiUrl + "v1/costCentersBusinessUnits?" + data, (res) => {
                vm.costCenters=[];
                res.data.forEach(item => { 
                    vm.costCenters.push({
                        code: item.id,
                        label: `${item.name} (${item.description})`
                    });
                });
            loading(false)
            });
        }, 500)

    }
}
</script>

<style scoped>
.d-center {
  display: flex;
  align-items: center;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}


</style>